import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { AWARD_NODE_FRAGMENT } from '../fragments'

const DELETE_AWARD_MUTATION = gql`
  mutation deleteAward($id: ID!) {
    deleteAward(id: $id) {
      results {
        ...AwardNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${AWARD_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DELETE_AWARD_MUTATION
